/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OntologyCategory
 */
export interface OntologyCategory {
    /**
     * 
     * @type {string}
     * @memberof OntologyCategory
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OntologyCategory
     */
    label: string;
}

/**
 * Check if a given object implements the OntologyCategory interface.
 */
export function instanceOfOntologyCategory(value: object): value is OntologyCategory {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function OntologyCategoryFromJSON(json: any): OntologyCategory {
    return OntologyCategoryFromJSONTyped(json, false);
}

export function OntologyCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): OntologyCategory {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
    };
}

export function OntologyCategoryToJSON(value?: OntologyCategory | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'label': value['label'],
    };
}

